// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3SrdC","insightsList":"newBusinessInsightsMenu_insightsList__3Vbn1","active":"newBusinessInsightsMenu_active__3IrDP"};